module.exports = __webpack_public_path__ + "static/media/Sharp-LQ084S3LG03-Mechanical-Drawing.55aabe88.gif";